import $ from 'jquery'
import {algoliasearch} from 'algoliasearch'
import instantsearch from 'instantsearch.js'
import {
    configure,
    menuSelect,
    geoSearch,
} from 'instantsearch.js/es/widgets'
import {history} from 'instantsearch.js/es/lib/routers'
import {
    connectSearchBox,
    connectCurrentRefinements,
} from 'instantsearch.js/es/connectors'
import {connectStats} from 'instantsearch.js/es/connectors';
import {connectHits} from 'instantsearch.js/es/connectors'
import {algoliaAppId, algoliaApiKey, partnerShopSearchIndex, productSearchIndex} from '../variables'
import {partnerShopHit, noResult} from '../templates'
import {dynamicUriTemplate, extractParamsFromUri} from '../functions'

// eslint-disable-next-line no-undef
const {__, _n, sprintf} = wp.i18n

// eslint-disable-next-line no-undef
const object = vnObject

const {
    query,
    city,
    country,
} = object.algoliaQueryStrings
var partnerShopsMainSlug = $('.js-partner-shops-link').data('url')

const slugs = {
    query,
    city,
    country,
}

var partnerShopsIndex = object.currentLanguageCode + partnerShopSearchIndex;

let partnerShopsSearch
const checkEl = document.querySelector('.pt-partner-shops__hits')
if (checkEl) {
    const searchClient = algoliasearch(algoliaAppId, algoliaApiKey)

    partnerShopsSearch = instantsearch({
        indexName: partnerShopsIndex,
        searchClient,
        insights: true,
        clickAnalytics: true,
        routing: {
            router: history({
                cleanUrlOnDispose: false,

                createURL({location, routeState}) {
                    const params = {
                        query: routeState.query,
                        country: routeState.country,
                        city: routeState.city,
                    };

                    return dynamicUriTemplate(
                        location.origin,
                        params,
                        partnerShopsMainSlug,
                        slugs
                    )
                },

                parseURL({location}) {
                    const params = extractParamsFromUri(location.href, slugs);

                    return {
                        query: params[slugs.query] && params[slugs.query][0],
                        country: params[slugs.country] && params[slugs.country][0],
                        city: params[slugs.city] && params[slugs.city][0],
                    };
                },
            }),

            stateMapping: {
                stateToRoute(uiState) {
                    const indexUiState = uiState[partnerShopsIndex] || {};
                    const res = {
                        query: indexUiState.query,
                        country: indexUiState.menu?.['country'],
                        city: indexUiState.menu?.['city'],
                    };

                    return res;
                },

                routeToState(routeState) {
                    return {
                        [partnerShopsIndex]: {
                            query: routeState.query,
                            menu: {
                                country: routeState.country,
                                city: routeState.city,
                            },
                        },
                    }
                },
            },
        },
    });

    const partnerShopItem = ({hits, sendEvent, widgetParams}) => {
        const container = document.querySelector(widgetParams.container)
        container.innerHTML = `
      ${
            hits.length
                ? hits
                    .map((item) => {
                        return partnerShopHit(item, 'g-col-12 g-col-md-6 g-col-lg-4')
                    })
                    .join('')
                : noResult
        }
  `

        container
            .querySelectorAll('.feed-partner-shop__wrapper')
            .forEach((element, index) => {
                element.addEventListener('click', (event) => {
                    sendEvent('click', hits[index], 'Partner shop Clicked')
                })
            })
    }

    const partnerShopItems = connectHits(partnerShopItem)

    const infoWindow = new window.google.maps.InfoWindow();

    function renderInfoContent(item) {
        console.log(item)
        return `
    <div class="map-infowindow">
      <strong>${item.title ?? item.name}</strong><br />
      ${item.shopAddress ?? item.address}<br />
      ${item._highlightResult.city.value ?? ''} ${item.zip ?? ''}
    </div>
  `;
    }

    function openInfo({item, map}) {
        infoWindow.setContent(renderInfoContent(item));
        if (item && item._geoloc) {
            infoWindow.setPosition({lat: item._geoloc.lat, lng: item._geoloc.lng});
        }
        infoWindow.open({map});
    }

    const renderSearchBox = (renderOptions, isFirstRender) => {
        const {query, refine, clear, isSearchStalled, widgetParams} =
            renderOptions
        const container = document.querySelector(widgetParams.container)

        if (isFirstRender) {
            const input = document.createElement('input')
            input.type = 'search'
            input.placeholder = widgetParams.placeholder

            container.insertAdjacentHTML('beforeend', object.loader)

            const reset = document.createElement('button')
            reset.type = 'reset'
            reset.insertAdjacentHTML('beforeend', '<i class="vn-icons-close"></i>')

            const submit = document.createElement('button')
            submit.type = 'submit'
            submit.insertAdjacentHTML('beforeend', '<i class="vn-icons-search"></i>')

            input.addEventListener('input', (product) => {
                refine(product.target.value)
            })

            reset.addEventListener('click', () => {
                clear()
            })

            container.appendChild(input)
            container.appendChild(reset)
            container.appendChild(submit)
        }

        container.querySelector('input').value = query
        container.querySelector('.vn-loader').hidden = !isSearchStalled
        container.querySelector('button[type="reset"]').hidden =
            isSearchStalled || !query
        container.querySelector('button[type="submit"]').hidden = isSearchStalled
    }

    const customSearchBox = connectSearchBox(renderSearchBox)

    partnerShopsSearch.addWidgets([
        customSearchBox({
            container: '.pt-partner-shops__search-handler',
            placeholder: __('Search...', 'vn'),
            showLoadingIndicator: false,
        }),

        menuSelect({
            container: '.pt-partner-shops__country-handler',
            attribute: 'country',
            limit: 99,
            sortBy: ['name:desc'],
            templates: {
                item(item, {html}) {
                    return html`<span>${item.label}</span>`;
                },
                defaultOption(data, {html}) {
                    return html`<span>${__('All countries', 'vn')}</span>`;
                },
            },
        }),

        menuSelect({
            container: '.pt-partner-shops__city-handler',
            attribute: 'city',
            limit: 99,
            sortBy: ['name:desc'],
            templates: {
                item(item, {html}) {
                    return html`<span>${item.label}</span>`;
                },
                defaultOption(data, {html}) {
                    return html`<span>${__('All cities', 'vn')}</span>`;
                },
            },
        }),

        geoSearch({
            container: '.pt-partner-shops__map-handler',
            googleReference: window.google,

            templates: {
                HTMLMarker(item, {html}) {
                    return html`<i class="vn-icons-map_pin map-marker" tabindex="0"
                                   aria-label="${item.name ?? 'Établissement'}"></i>`;
                },
            },

            customHTMLMarker: {
                events: {
                    click({item, map}) {
                        openInfo({item, map});
                    },
                    mouseover({item, map}) {
                        openInfo({item, map});
                    },
                    mouseout() {
                    },
                    keydown({event, item, map}) {
                        if (event.key === 'Enter' || event.key === ' ') {
                            openInfo({item, map});
                        }
                    },
                },
            },
        }),

        partnerShopItems({
            container: '.pt-partner-shops__hits',
        }),

        configure({
            hitsPerPage: 99,
        }),
    ])

    partnerShopsSearch.start()
}

export {partnerShopsSearch}

$('.js-show-mobile-modal').on('click', function () {
    $('.js-partner-shops-mobile-modal').slideDown();
});

$('.js-close-mobile-modal').on('click', function () {
    $('.js-partner-shops-mobile-modal').slideUp();
});
